import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import './../../../styles/global.scss';
import Skeleton from 'react-loading-skeleton';
import {ChartColors} from "../constants/chart-color-constants"
import {from} from "linq";

class FieldDonutChart extends Component {

    constructor(props) {
        super(props);

        this.groupedData = this.groupData(this.props.data, this.props.field);

        this.state = {
            labels: this.generateLabels(),
            datasets: this.generateConsumptionDataset(),
            options: this.generateConsumptionOptions(),
            responsive: true
        };
    }

    generateLabels = () => {
        return this.groupedData.map(x => x.label);
    };

    groupData(data, field) {
        const d = from(data)
            .groupBy(x => x[field], null, (key, group) => {
                return {
                    label: key,
                    count: group.count()
                }
            }).toArray();
        return d;
    }

    generateConsumptionDataset() {
        let index = 0;
        const colors = [
            ChartColors.a,
            ChartColors.b,
            ChartColors.c,
        ];
        return [
            {
                data: this.groupedData.map(x => x.count),
                backgroundColor: this.groupedData.map(x => {
                    if(index >= colors.length) { index = 0;}
                    return colors[index++];
                })
            }
        ];
    }

    generateConsumptionOptions() {
        return {
            legend: {
                position: 'bottom'
                
            },
            title: {
                text: this.props.title || <Skeleton />,
                display: true,
                fontSize: 13
            }
        };
    }

    render() {
        const legendHoverPlugin = {
            id: 'legendHoverPlugin',
            afterEvent: (chart, event) => {
        
                const { type, x, y, native } = event;
                if (!native) return; // Ensure native event is available
        
                const { canvas, legend } = chart;
        
                if (type === 'mousemove') {
                    // Find existing tooltip, or create a new one if none exists
                    let tooltip = document.querySelector('.custom-tooltip');
                    if (!tooltip) {
                        tooltip = document.createElement('div');
                        tooltip.className = 'custom-tooltip';
                        tooltip.style.position = 'absolute';
                        tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                        tooltip.style.color = 'white';
                        tooltip.style.padding = '5px';
                        tooltip.style.borderRadius = '3px';
                        tooltip.style.pointerEvents = 'none';
                        document.body.appendChild(tooltip);
                    }
        
                    let found = false;
                    legend.legendItems.forEach((item, index) => {
                        const { left, top, width, height } = legend.legendHitBoxes[index];
        
                        if (x >= left && x <= left + width && y >= top && y <= top + height) {
                            tooltip.style.top = `${native.clientY + 20}px`;
                            tooltip.style.left = `${native.clientX + 20}px`;
                            tooltip.innerHTML = "Legend changes only affects the chart and not the data below."; // Simple message
                            tooltip.style.display = 'block'; // Show the tooltip
                            canvas.style.cursor = 'pointer';
                            found = true;
                        }
                    });
        
                    if (!found) {
                        tooltip.style.display = 'none'; // Hide the tooltip if not hovering over a legend item
                        canvas.style.cursor = 'default';
                    }
                } else {
                    const tooltip = document.querySelector('.custom-tooltip');
                    if (tooltip) {
                        tooltip.style.display = 'none'; // Hide the tooltip for other events
                    }
                }
            }
        };
        
        return (
            <div className="chart">

                <Doughnut
                    width={0}
                    responsive={true}
                    data={this.state || <Skeleton />}
                    onElementsClick={this.props.onElementsClick} // Pass the callback function here
                    options={{
                        title: {
                            display: true,
                            text: this.props.title || <Skeleton />
                        },
                        legend: {
                            position: 'bottom',
                            display: (this.props.showLegend !== undefined) ? this.props.showLegend : true,
                            //onClick: () => {} // Disable clicking on the legend items
                        }
                    }}

                    plugins={[legendHoverPlugin]}
                />
            </div>
        )
    }
}

export default FieldDonutChart;
